// extracted by mini-css-extract-plugin
export var boxItems = "_8s-1";
export var boxItemsLg = "_8s-2";
export var button = "_8s-7";
export var buttonLg = "_8s-8";
export var filterGroupBox = "_8s-0";
export var icon = "_8s-3";
export var iconSecondary = "_8s-6";
export var iconWrapper = "_8s-4";
export var iconWrapperLg = "_8s-5";